import { INSPECTION_PAYLOAD_TYPE } from '@/constant/qsf'
import { atom, useAtom } from 'jotai'
export const inspectionMasterDataFilter = atom([])

export const defaultInspectionFilter: INSPECTION_PAYLOAD_TYPE = {
  planned_date: null,
  submitted_date: null,
  status: null,
  result: null,
  inspectors: null,
  query: null,
  suppliers: null,
  countries: null,
  factories: null,
  order_ids: null,
  style_ids: null,
  brands: null,
  inspection_type_ids: null,
}

export const advanceFilterOrderItemAtom = atom([])

export const useAdvanceSelectedOrderItem = () => {
  const [getAtomSelectedOrders, setAtomSelectedOrders] = useAtom(
    advanceFilterOrderItemAtom
  )

  return {
    getAtomSelectedOrders,
    setAtomSelectedOrders,
    resetAtomSelectedOrders: () => setAtomSelectedOrders([]), // Optional reset function
  }
}
